import lockersWordmark from 'assets/images/logo/Lockers_Logo_Horizontal.png';
import * as React from 'react';

/**
 * The Lockers horizontal lockup — tile + "Zezamii / Lockers" — as worn by the Lockers footer.
 *
 * ⚠️ RASTER (`assets/images/logo/Lockers_Logo_Horizontal.png`, 383×103 with alpha). See
 * LogoLockerApp for why this folder has two PNG-backed logos among inline SVGs, and what that
 * costs. The one extra caveat here: the source is 383px wide against a 149px render, so it has
 * ~2.6x of headroom — comfortable at 2x DPR, a touch short at 3x. If it ever looks soft on a
 * Pro Display, the fix is a larger export, not a change in this file.
 *
 * DEFAULT HEIGHT IS 40, NOT THE SOURCE'S 103. It is deliberately the same 40 that
 * LogoAccessWithText renders at, because the two sit side by side in the footer — the previous
 * wordmark defaulted to 22 and read as the smaller, secondary of the pair. Width is derived from
 * the source's own 3.718:1 so the lockup can never be squashed by setting one dimension alone.
 */
const ASPECT = 383 / 103;
const DEFAULT_HEIGHT = 40;

const LogoLockersWithText = ({ width, height, size, style, focusable, inverted, color, ...props }) => {
	const h = height ?? size ?? DEFAULT_HEIGHT;
	const w = width ?? Math.round(h * ASPECT);

	return (
		<img
			src={lockersWordmark}
			alt=''
			width={w}
			height={h}
			{...props}
			style={{ display: 'block', ...style }}
		/>
	);
};

export default LogoLockersWithText;
